import Placeholder from '@atlaskit/react-ufo/placeholder';
import { useAnalyticsWebClient } from '@dev-agents/analytics';
import { ErrorBoundary } from '@dev-agents/error-boundary';

import { LoadingSkeleton } from '../common/components/skeleton/skeleton';
import { DevAgentIntlProvider } from '../services/intl-provider';
import { ConsentBannerComponent } from '../utils/consent-banner';

import { BlockingAtlassianProviders } from './app/providers';
import { AppRouter } from './app-router';

export const App = () => {
	const analyticsWebClient = useAnalyticsWebClient();

	return (
		<ErrorBoundary
			componentName="App"
			onError={(err) => {
				analyticsWebClient.sendOperationalEvent({
					action: 'error',
					actionSubject: 'appComponent',
					source: 'app',
					attributes: {
						message: err.message,
					},
				});
			}}
		>
			<Placeholder name="dev-agents-app" fallback={<LoadingSkeleton />}>
				<DevAgentIntlProvider>
					<BlockingAtlassianProviders>
						<ConsentBannerComponent />
						<AppRouter />
					</BlockingAtlassianProviders>
				</DevAgentIntlProvider>
			</Placeholder>
		</ErrorBoundary>
	);
};
